import { render } from "./OutOfOfficeTable.vue?vue&type=template&id=09ea8972"
import script from "./OutOfOfficeTable.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__